import React, { useEffect, useState } from "react";
import { Panel } from "../components/Panel";
import { usePlayer } from "../context/PlayerContext";
import { api } from "../api/client";
import { Skull, Swords, Crown, Zap, Flame, Medal, Rocket, Gift, Users, Trophy, Dices, Lock, Check, Coins, Loader2 } from "lucide-react";

const ICONS = { skull: Skull, swords: Swords, crown: Crown, zap: Zap, flame: Flame, medal: Medal, rocket: Rocket, gift: Gift, users: Users, trophy: Trophy, dices: Dices };

export default function Achievements({ onClose }) {
  const { applyUser } = usePlayer();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.achievements().then(({ data }) => { setItems(data.achievements || []); if (data.user) applyUser(data.user); }).catch(() => setItems([]));
  }, []); // eslint-disable-line

  const unlocked = items ? items.filter((i) => i.unlocked).length : 0;
  const total = items ? items.length : 0;

  return (
    <Panel title="Awards" onClose={onClose} wide>
      <div className="flex items-center justify-between mb-4">
        <div className="text-slate-400 text-sm">Unlock awards by smashing, winning and playing with friends.</div>
        <div className="card px-3 py-1.5 flex items-center gap-1.5" data-testid="achievements-count">
          <Trophy size={16} className="text-amber-400" />
          <span className="font-black text-white">{unlocked}<span className="text-slate-500">/{total}</span></span>
        </div>
      </div>

      {items === null && <div className="text-slate-500 text-sm py-8 flex items-center justify-center gap-2"><Loader2 size={16} className="animate-spin" /> Loading awards...</div>}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5" data-testid="achievements-grid">
        {items && items.map((a) => {
          const Icon = ICONS[a.icon] || Medal;
          const pct = Math.max(0, Math.min(1, a.progress / a.target));
          return (
            <div key={a.id}
              className={`card p-3 flex items-center gap-3 relative overflow-hidden transition-all ${a.unlocked ? "border-amber-500/60" : "opacity-90"}`}
              data-testid={`achievement-${a.id}`}>
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${a.unlocked ? "bg-gradient-to-br from-amber-400 to-orange-600" : "bg-slate-800"}`}>
                {a.unlocked ? <Icon size={24} className="text-black" /> : <Lock size={20} className="text-slate-500" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`font-black text-sm ${a.unlocked ? "text-white" : "text-slate-300"}`}>{a.name}</span>
                  {a.unlocked && <Check size={14} className="text-green-400 shrink-0" />}
                </div>
                <div className="text-[11px] text-slate-400 leading-tight">{a.desc}</div>
                {!a.unlocked && (
                  <div className="mt-1.5">
                    <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden">
                      <div className="h-full bg-cyan-500 rounded-full" style={{ width: `${pct * 100}%` }} />
                    </div>
                    <div className="text-[10px] text-slate-500 mt-0.5">{a.progress.toLocaleString()} / {a.target.toLocaleString()}</div>
                  </div>
                )}
              </div>
              <div className={`flex flex-col items-end gap-0.5 text-xs font-bold shrink-0 ${a.unlocked ? "text-green-400" : "text-amber-400/80"}`}>
                <span className="flex items-center gap-1"><Coins size={13} /> {(a.reward.coins || 0).toLocaleString()}</span>
                {a.reward.xp ? <span className="flex items-center gap-1 text-cyan-400"><Zap size={12} /> {a.reward.xp}</span> : null}
              </div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
